import { createFileRoute } from '@tanstack/react-router';
import { VisibilityGuide } from '@/components/blog/VisibilityGuide';
import { guideTitle, guideDescription } from '@/data/knowledge';
import { buildBreadcrumb, ldJson, ORGANIZATION_ID } from '@/lib/site-schema';

const url = 'https://agenciaseoevolution.com/blog/visibilidad-ia-empresas';
export const Route = createFileRoute('/blog/visibilidad-ia-empresas')({
  head: () => ({
    meta: [
      { title: 'Visibilidad en Google e IA para empresas | SEOEVOLUTION' },
      { name: 'description', content: guideDescription },
      { name: 'author', content: 'Ángel Ruz' },
      { property: 'og:title', content: guideTitle },
      { property: 'og:description', content: guideDescription },
      { property: 'og:type', content: 'article' },
      { property: 'og:url', content: url },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: guideTitle },
      { name: 'twitter:description', content: guideDescription },
    ],
    links: [{ rel: 'canonical', href: url }],
    scripts: [ldJson({
      '@context': 'https://schema.org', '@type': 'Article', '@id': `${url}#article`,
      headline: guideTitle, description: guideDescription, mainEntityOfPage: url,
      author: { '@type': 'Person', '@id': 'https://agenciaseoevolution.com/angel-ruz#person', name: 'Ángel Ruz', url: 'https://agenciaseoevolution.com/angel-ruz' },
      publisher: { '@id': ORGANIZATION_ID }, datePublished: '2026-10-10', dateModified: '2026-11-02', inLanguage: 'es', articleSection: 'Visibilidad en IA',
    }), ldJson(buildBreadcrumb([{ name: 'Conocimiento', path: '/blog' }, { name: guideTitle, path: '/blog/visibilidad-ia-empresas' }]))],
  }),
  component: VisibilityGuide,
});